export default __webpack_public_path__ + "static/media/2.16a158e4.jpg";